import { useEffect } from 'react';
import { useLocation } from '@/hooks/lib/react-router/useLocation';
/**
 * ルーティング変更時に処理を実行するカスタムフック
 * @param handleLocationChange ルーティング変更時の処理
 */
export const useOnLocationChange = (handleLocationChange) => {
    const location = useLocation();
    useEffect(() => handleLocationChange(location), [handleLocationChange, location]);
};
